import {
  viandas2Get,
  viandas2Post,
  viandas2Put,
  viandas2Delete,
} from "../../../common/service/viandas2Client";

export const getDisponibilidad = (desde, hasta) =>
  viandas2Get("/rrhh/disponibilidad", { desde, hasta });

export const cargarSemanal = (registros) =>
  viandas2Post("/rrhh/disponibilidad", registros);

export const actualizarFeriado = (id, esFeriado) =>
  viandas2Put(`/rrhh/disponibilidad/${id}`, { es_feriado: esFeriado });

export const eliminarDisponibilidad = (id) =>
  viandas2Delete(`/rrhh/disponibilidad/${id}`);
